import { ALLOWED_CLASSES } from "conts/allowedClasses";

/**
 * Returns true when the search button should be disabled.
 * - typeOfClass must be selected and be an allowed class
 * - online_type must be selected
 * - location is additionally required when online_type is "offline"
 */
export const isFiltersSearchDisabled = (filters) => {
    const online_type = filters.online_type?.value || "";
    
    // Check if typeOfClass is valid and is in the allowed classes list
    const isValidClass = filters.typeOfClass && 
        ALLOWED_CLASSES.some(
            allowed => allowed.toLowerCase() === filters.typeOfClass.label?.toLowerCase()
        );

    return (
        !isValidClass ||
        !online_type ||
        (online_type === "offline" && !filters.location)
    );
};

export const getFiltersSearchDisabledMessage = (filters) => {
    const online_type = filters.online_type?.value || "";
    const needsLocation = online_type === "offline" && !filters.location;

    if (needsLocation) {
        return "Choose an available class, lesson type, and location";
    }

    return "Choose an available class and lesson type";
};